module.exports = __webpack_public_path__ + "static/media/12.aa82f9e3.jpg";